"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOption = exports.StyledOptionGroupHorizontal = exports.StyledOptionGroupVertical = exports.StyledOptionGroup = exports.StyledHeader = exports.StyledWrapper = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.StyledHeader = styled_components_1.default.div `
  text-align: left;
  padding-top: ${({ theme, hasDivider }) => hasDivider && ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
  padding-bottom: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};

  border-top: ${({ theme, hasDivider }) => hasDivider && `1px solid ${theme.Color.Neutrals.Border}`};
`;
exports.StyledOptionGroup = styled_components_1.default.div `
  ${({ orientation }) => orientation === 'vertical'
    ? exports.StyledOptionGroupVertical
    : exports.StyledOptionGroupHorizontal};
`;
exports.StyledOptionGroupVertical = (0, styled_components_1.css) `
  display: flex;
  flex-direction: column;
`;
exports.StyledOptionGroupHorizontal = (0, styled_components_1.css) `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
exports.StyledOption = styled_components_1.default.div `
  padding-bottom: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  padding-right: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.XSmall)};
`;
//# sourceMappingURL=StockFilterOptionGroup.style.js.map